
import { smartImagePath } from '@/tools/ObjectHelper'
import Icon from 'vux/src/components/icon/index.vue'

export default {
components: {
Icon
},
data () {
return {
smartImagePath,
videoUrl: '',
posterUrl: '',
isShow: false
}
},
watch: {
isShow (val) {
if (val) {

if (/android/i.test(navigator.userAgent)) {
history.pushState(null, null, location.href)
window.addEventListener('popstate', this.closeGallery)
}

document.querySelector('.video-prevent-pass-through').className =
'video-prevent-pass-through video-prevent-pass-through-show'
document.querySelector('.video-slider').className = 'video-slider open'
document.getElementById('video-player').play()
} else {
document.getElementById('video-player').pause()
window.removeEventListener('popstate', this.closeGallery)
setTimeout(
() =>
(document.querySelector('.video-prevent-pass-through').className =
'video-prevent-pass-through'),
400
)
document.querySelector('.video-slider').className = 'video-slider close'
}
}
},
methods: {
handleClose () {
this.isShow = false
}
}
}
